import _ from 'lodash';
import checkIsPaymentRequiredForItinerary from './checkIsPaymentRequiredForItinerary';
import getTripItineraries from './getTripItineraries';

const getTripModes = (trip, travelAgency, doIncludeItinerariesOnHold = true) => {
  if (!trip) {
    return {
      itinerariesToBook: [],
      itinerariesToBookWithPaymentMethod: [],
      itinerariesOnHold: [],
    };
  }
  const itineraries = getTripItineraries(trip);
  const itinerariesOnHold = doIncludeItinerariesOnHold ? trip.itinerariesOnHold || [] : [];
  if (itinerariesOnHold.length) {
    itinerariesOnHold.forEach((m) => {
      _.remove(
        itineraries,
        (t) => t.mode === m.itineraryMode && (t.id || 0) === (m.itineraryId || 0),
      );
    });
  }

  const doAlwaysRequirePayment = travelAgency && travelAgency.doAlwaysRequirePayment;

  const itinerariesToBookWithPaymentMethod = doAlwaysRequirePayment
    ? itineraries
    : _.filter(itineraries, (it) => checkIsPaymentRequiredForItinerary(it));

  return {
    itinerariesToBook: _.uniq(_.map(itineraries, 'mode')),
    itinerariesToBookWithPaymentMethod: _.uniq(_.map(itinerariesToBookWithPaymentMethod, 'mode')),
    itinerariesOnHold: _.uniq(_.map(itinerariesOnHold, (i) => i.itineraryMode)),
    hasItinerariesWithMarkup: !!_.find(itineraries, (it) => (it.cost || {}).doShowMarkupAmount),
  };
};

export default getTripModes;
